import { createFileRoute } from '@tanstack/react-router';

import { handleLegacyRedirect } from '@src/corelib/utils/redirectsUtils';

export const Route = createFileRoute('/contact-2')({
  beforeLoad: handleLegacyRedirect('/contact'),
});
